module.exports = __webpack_public_path__ + "img/bp_logo.2b4c4d2f.svg";